import React, { useState } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const stopTypes = ["PICKUP", "DROP_OFF", "CUSTOMS", "OTHER"];

const AddStopModal = ({ onClose, onAddStop }) => {
  const [form, setForm] = useState({
    stopType: "",
    stopName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    scheduledGateIn: "",
    scheduledGateOut: "",
  });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (!form.stopType || !form.stopName || !form.city) {
      return alert("Please fill in required fields: Stop Type, Name, City.");
    }
    onAddStop(form); // Pass back to parent
    onClose(); // Or reset if using Add Another
  };

  return (
    <motion.div
      className="fixed inset-0 z-[1000] bg-black bg-opacity-40 flex items-center justify-center px-fluid-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-xl w-full max-w-3xl p-fluid-3 space-y-fluid-3"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        {/* Header */}
        <div className="flex flex-col items-center space-y-fluid-1">
          <div className="bg-[#1e2a74] rounded-full p-fluid-2 text-white">
            <MapPin size={28} />
          </div>
          <h2 className="text-fluid-xl font-semibold text-[#111827]">
            Add New Stop
          </h2>
          <p className="text-fluid-base text-gray-600 text-center">
            Enter stop details for the shipment
          </p>
        </div>

        {/* Form Fields */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-fluid-2 text-fluid-sm text-gray-800">
          <div>
            <label className="block font-medium mb-1">Stop Type *</label>
            <select
              className="w-full border rounded px-3 py-2"
              value={form.stopType}
              onChange={(e) => handleChange("stopType", e.target.value)}
            >
              <option value="">Select</option>
              {stopTypes.map((type) => (
                <option key={type}>{type}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block font-medium mb-1">Stop Name *</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.stopName}
              onChange={(e) => handleChange("stopName", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Address Line 1</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.addressLine1}
              onChange={(e) => handleChange("addressLine1", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Address Line 2</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.addressLine2}
              onChange={(e) => handleChange("addressLine2", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">City *</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.city}
              onChange={(e) => handleChange("city", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">State</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.state}
              onChange={(e) => handleChange("state", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Zip Code</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.zipCode}
              onChange={(e) => handleChange("zipCode", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Country</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={form.country}
              onChange={(e) => handleChange("country", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Scheduled Gate-In</label>
            <input
              type="datetime-local"
              className="w-full border rounded px-3 py-2"
              value={form.scheduledGateIn}
              onChange={(e) => handleChange("scheduledGateIn", e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Scheduled Gate-Out</label>
            <input
              type="datetime-local"
              className="w-full border rounded px-3 py-2"
              value={form.scheduledGateOut}
              onChange={(e) => handleChange("scheduledGateOut", e.target.value)}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-fluid-button-x py-fluid-button-y border border-gray-300 rounded text-gray-700 hover:bg-gray-100 text-fluid-sm"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-fluid-button-x py-fluid-button-y bg-[#1e2a74] text-white hover:bg-[#18225c] text-fluid-sm rounded font-semibold transition"
          >
            Confirm
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default AddStopModal;
